/**
 * Engagement - comments and WhatsApp-style reactions on any entity, identified by (model_type, model_id).
 * API: /ms/engagement (sky360-ms engagement module).
 */

/** model types that can be commented / reacted on - mirrors sky360-ms ModelType and PHP Comment::MODEL_TYPE_* */
export enum EngagementModelType {
  TUTORIAL = 35,
  VIDEO_NOTIFICATION = 41,
  /** guide explorer guide - model id is the guide taskId */
  GUIDE = 42,
  COMMENT = 43,
}

export interface ReactionsSummary {
  /** emoji -> count */
  counts: Record<string, number>;
  /** the caller's reaction */
  mine: string | null;
}

export interface EngagementConfig {
  comments: boolean;
  reactions: boolean;
  emojis: string[];
}

export interface EngagementComment {
  id: number;
  parent_id: number | null;
  body: string;
  author: { id: number; name: string | null; agency_name: string | null };
  date_created: string;
  edited: boolean;
  reply_count: number;
  can_edit: boolean;
  can_delete: boolean;
  can_block_author: boolean;
  reactions: ReactionsSummary;
  replies?: EngagementComment[];
}

/** one page of GET /ms/engagement/:modelType/:modelId */
export interface EngagementThreadPage {
  config: EngagementConfig;
  permissions: { can_comment: boolean; can_react: boolean; can_moderate: boolean; is_blocked: boolean };
  reactions: ReactionsSummary;
  comment_count: number;
  comments: EngagementComment[];
  next_before: number | null;
}

export interface EngagementSummaryItem {
  reactions: ReactionsSummary;
  comment_count: number;
}

export interface EngagementSummary {
  config: EngagementConfig;
  items: Record<string, EngagementSummaryItem>;
}

/** texts - each host app passes its own translations (EngagementTranslationsProvider) */
export interface EngagementTranslations {
  react: string;
  comments: string;
  addComment: string;
  writeComment: string;
  writeReply: string;
  send: string;
  reply: string;
  edit: string;
  save: string;
  cancel: string;
  delete: string;
  deleteConfirm: string;
  hide: string;
  hideConfirm: string;
  blockUser: string;
  blockConfirm: string;
  blockReason: string;
  blockHideComments: string;
  blockedSuccess: string;
  blockedNotice: string;
  edited: string;
  loadOlder: string;
  showReplies: string;
  showMore: string;
  showLess: string;
  noComments: string;
  error: string;
  moreEmojis: string;
  searchEmoji: string;
  reactionCount: string;
  addReaction: string;
  removeReaction: string;
  showComments: string;
  hideComments: string;
}

export const DEFAULT_EMOJIS = ['👍', '❤️', '😂', '😮', '😢', '🙏'];
export const COMMENT_MAX_LENGTH = 2000;
